<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19.028"
    height="13.388"
    viewBox="0 0 19.028 13.388">
    <g id="ic-actions-trash" transform="translate(4.264 0.75)">
      <line
        id="Line_54"
        data-name="Line 54"
        x1="17"
        y2="9"
        transform="translate(-3.25 2.443)"
        fill="none"
        stroke="#657786"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        stroke-width="1.5" />
      <rect
        id="Rectangle_15"
        data-name="Rectangle 15"
        width="10.5"
        height="2.333"
        rx="1"
        fill="none"
        stroke="#657786"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        stroke-width="1.5" />
      <path
        id="Path_41"
        data-name="Path 41"
        d="M13.167,5.81V14.2A1.167,1.167,0,0,1,12,15.365H6.167A1.167,1.167,0,0,1,5,14.2V5.81"
        transform="translate(-3.833 -3.477)"
        fill="none"
        stroke="#657786"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        stroke-width="1.5"
        fill-rule="evenodd" />
    </g>
  </svg>
</template>
